import {
	throttle
} from 'lodash-es';
import Cookies from 'js-cookie';

export const Helpers = (function () {
	'use strict';

	function init() {
		cookie_banner();
		responsive_videos();
		body_scroll();
		accordions();
		first_headline();
		footer();
		load_more_cat();
		comments_panel();
		form_validation();
	}

	function form_validation() {

		$('input[required]').each(function () {



			$(this).on({
				invalid: function () {
					run_validation($(this)[0]);
				},
				input: function () {
					run_validation($(this)[0]);
				}
			});
		});

	}

	function run_validation(elem) {
		var message = ($(elem).attr('type') == 'email') ? 'Please enter a valid email address.' : 'Required field.';
		if (elem.value === '') {
			elem.setCustomValidity(message);
		} else if (elem.validity.typeMismatch) {
			elem.setCustomValidity(message);
		} else {
			elem.setCustomValidity('');
		}
	}

	function comments_panel() {

		$(window).on('keyup', function (e) {
			// console.log(e.keyCode);
			// ESC key
			if (e.keyCode == 27) {
				if ($('#comments-panel.open').length) {
					$('#comments-panel').removeClass('open');
				}
			}
		});

		$(document).on('keydown', function (e) {
			if ($('#comments-panel').hasClass('open')) {
				$(this).attr('tabindex', '-1').focus().removeAttr('tabindex');
				$(document).on('keydown', function (e) {
					if ($('.comments-panel').hasClass('open') && e.keyCode === 9) {
						var focusableElements = $('.comments-panel').find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), *[tabindex="0"]');
						var firstElement = focusableElements.first();
						var lastElement = focusableElements.last();
						var currentElement = $(document.activeElement);

						if (!currentElement.is('.comments-panel') && !currentElement.is(focusableElements)) {
							firstElement.focus();
							e.preventDefault();

						} else if (e.shiftKey && currentElement.is(firstElement)) {
							lastElement.focus();
							e.preventDefault();

						} else if (!e.shiftKey && currentElement.is(lastElement)) {
							firstElement.focus();
							e.preventDefault();
						}
					}
				});
			}
		});

		$('.btn[data-open-comments]').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			
			var tabindex = $(this).attr('tabindex');
			
			$(this).blur().attr('tabindex', tabindex);

			$(document).one('click', function closeComments(event) {
				var sameEl = ($('#comments-panel').html() == $(event.target).html());
				if (!sameEl && $('#comments-panel').has(event.target).length === 0 && $('.comments-panel.open').length) {
					$('#comments-panel button.close').click();
				} else {
					$(document).one('click', closeComments);
				}
			});

			$('#comments-panel').addClass('open');
			//$('#comments-panel').attr("aria-label", "Focused on Comment Dialog");
			$('#comments-panel').focus();

		});

		$('#comments-panel button.close').on('click', function (e) {
			e.preventDefault();
			$('#comments-panel').removeClass('open');
			$('#comments-panel').blur();
			$('#comments-panel').removeAttr('aria-label');
			$('body').attr('tabindex', '-1').focus().removeAttr('tabindex');
			$('.comment-button-container').find('a').focus();
		});

	}

	function first_headline() {
		// let $article_content = $('.article-content');
		// if ( $article_content.length ) {
		// 	let $first_block = $article_content.find('.pxblock').eq(0).find('.wysiwyg');
		// 	$first_block.find(':first-child').html(function (i, t) {
		// 		var hhNumber = 3;
		// 		var words = t.split(/\s+/);
		// 		return "<strong>" + words.slice(0,hhNumber).join(" ") + "</strong> " + words.slice(hhNumber).join(" ");
		// 	});
		// }
	}

	function cookie_banner() {
		let banner = document.querySelector('.cookie-banner');

		if (!banner) return;

		banner.querySelectorAll('button').forEach((btn) => {
			btn.addEventListener('click', (ev) => {
				ev.preventDefault();

				let acceptance = btn.classList.contains('accept') ? 'yes' : 'no';

				Cookies.set('acceptedCookiePrompt', acceptance);
				window.location.reload();
			});
		});
	}

	function responsive_videos() {
		let responsiveVideos = document.querySelectorAll('.responsive-video');

		if (!responsiveVideos) return;

		responsiveVideos.forEach((vid) => {
			let playButton = vid.querySelector('.play-button');
			let videoEl = vid.querySelector('video');
			let iframe = vid.querySelector('iframe');
			let cover = vid.querySelector('.responsive-video__cover');

			if (!playButton) return;

			if (iframe) {
				let iframeOriginalSrc = iframe.getAttribute('src');

				iframe.setAttribute('src', iframe.getAttribute('src') + '&showinfo=0&controls=0');
			}

			playButton.addEventListener('click', (ev) => {
				vid.classList.add('playing');
			});

			playButton.addEventListener('transitionend', (ev) => {
				playButton.parentNode.removeChild(playButton);

				if (cover) {
					cover.parentNode.removeChild(cover);
				}

				if (videoEl) {
					videoEl.setAttribute('controls', 'controls');
					videoEl.play();
				}

				if (iframe) {
					iframe.setAttribute('src', iframe.getAttribute('src') + '&autoplay=1');
				}
			});
		});
	}

	function body_scroll() {
		var scrollY = 0;
		window.addEventListener(
			'scroll',
			throttle(() => {
				window.scrollY > 100 ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');

				if (window.scrollY > scrollY) {
					document.body.classList.add('scroll-down');
					document.body.classList.remove('scroll-up');
				} else {
					document.body.classList.add('scroll-up');
					document.body.classList.remove('scroll-down');
				}

				scrollY = window.scrollY;

			}, 150)
		);
	}

	function getUrlParams(search) {
		if (search.length <= 1) return {};
		const hashes = search.slice(search.indexOf('?') + 1).split('&');
		const params = {};
		hashes.map((hash) => {
			const [key, val] = hash.split('=');
			params[key] = decodeURIComponent(val);
		});
		return params;
	}

	function accordions() {
		let accordions = Array.from(document.querySelectorAll('[data-accordion]'));

		if (accordions.length === 0) return;

		accordions.forEach((accordion) => {
			let trigger = accordion.querySelector('[data-accordion-trigger]');

			trigger.addEventListener('click', (ev) => {
				accordion.classList.toggle('accordion-open');
			});
		});
	}

	function getCurrentPostIDs() {
		var ids = [];
		$('.grid-bottom').each(function () {
			$(this).find('article').each(function () {
				ids.push($(this).data('id'));
			});
		});

		return ids;
	}

	function load_more_cat() {
		$('#load-more-cat').click(function (e) {
			e.preventDefault();

			const button = $(this),
				excludePosts = JSON.parse($(this).attr('data-exclude-posts')),
				catId = parseInt(button.attr('data-cat-id')),
				scrollPos = $(window).scrollTop();

			if (button.hasClass('loading')) {
				return;
			}
			// otherwise, go ahead and grab new content
			else {
				const data = {
					action: 'px_load_more_cat',
					exclude_posts: excludePosts,
					cat_id: catId,
					page: pxmodules_params.current_page
				};

				$.ajax({
						type: 'POST',
						data: data,
						url: pxmodules_params.ajaxurl,
						beforeSend: function (xhr) {
							button.addClass('loading');
						}
					})
					.done(function (response, status, xhr) {

						if (response) {
							const $newGrid = $('<div class="grid-bottom posts">' + response + '</div>')
							$('.category-bottom .container').append($newGrid);
							$newGrid.find(' > article:first-child > a:first-child').focus()
							pxmodules_params.current_page++;

							if (pxmodules_params.current_page >= pxmodules_params.max_page) {
								button.remove();
							}

						} else {
							button.remove();
						}

						// update excluded IDs
						$('.category-bottom').find('article').each(function () {
							var article_id = $(this).data('id');
							if (excludePosts.indexOf(article_id) == -1) {
								excludePosts.push(article_id);
							}

							// debug IDs
							// $(this).css('position', 'relative');
							// $(this).append('<div style="position: absolute; top: 0; right: 0; padding: 5px; font-size: 12px; background: red; color: #fff;">'+ article_id +'</div>');
						});

						var json_exclude = JSON.stringify(excludePosts);

						$('#load-more-cat').attr('data-exclude-posts', json_exclude);


					})
					.fail(function (xhr, textStatus) {
						window.addAlert('error', 'Failed to load more posts. Please try again.');
					})
					.always(function () {
						$(window).scrollTop(scrollPos);
						button.removeClass('loading');
					})
			}
		})
	}
	
	function footer() {
		$('.footer-navigation').find('nav').attr('aria-label', 'footer');
	}

	return {
		init: init,
		getUrlParams: getUrlParams,
	};
})();
